/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment';
import React, { Component } from 'react';
import * as stringParser from '../../../util/string.util'

// let connection = null
let blinkTime = null
export default class ComboBook extends Component {
    _ismounted = false
    constructor(props) {
        super(props);
        this.state = {
            runnersTotalExpo: {},
            book: {},
            market: {},
            lastBook: {},
            areAllZero: true
        };
    }
    componentDidMount() {
        this.setExpoBookData();
    }

    componentWillReceiveProps(){
        this.setExpoBookData();
    }

    componentWillUnmount() {
       
    }

    setExpoBookData(){
        const notLineRunnerIdList = this.props.notLineRunnerIdList;
        const runnerKeys = Object.keys(notLineRunnerIdList);
        let runnersTotalExp = {};
        let areAllZro = true;
        for( const kys of runnerKeys){
            runnersTotalExp[kys] = 0;
        }
        for( const expky of Object.keys(this.props.mktExpos)){
            const expmkt = this.props.mktExpos[expky];
            if(!!expmkt && expmkt!=={} && expmkt.marketBettingType !== "LINE" && !!expmkt.runnersExposure){
                for( const vls of Object.values(expmkt.runnersExposure)){

                    let findkey = "";

                    for( const kys of runnerKeys){
                        if(notLineRunnerIdList[kys].includes(vls.runnerId) ){
                            findkey = kys;
                            break;
                        }
                    }
                    if(findkey !== ""){
                        runnersTotalExp[findkey] += vls.sharingMe;
                    }
                }       
            }
        }

        for( const expagky of Object.keys(this.props.mktAgentExpos)){
            const expagmkt = this.props.mktAgentExpos[expagky];
            if(!!expagmkt && expagmkt!=={} && expagmkt.marketBettingType !== "LINE" && !!expagmkt.runnersExposure){
                for( const vls of Object.values(expagmkt.runnersExposure)){

                    let findkey = "";

                    for( const kys of runnerKeys){
                        if(notLineRunnerIdList[kys].includes(vls.runnerId) ){
                            findkey = kys;
                            break;
                        }
                    }
                    if(findkey !== ""){
                        runnersTotalExp[findkey] += vls.sharingUp;
                    }
                }       
            }
        }

        for( const vkys of runnerKeys){
            if(runnersTotalExp[vkys] !== 0)
            {
                areAllZro = false;
                break;
            }
        }

        this.setState({runnersTotalExpo: runnersTotalExp, areAllZero: areAllZro},()=>{
            if(areAllZro && this.props.isComboBookOpen){
                this.props.toggleComboBookOpen();
            }
        });

    }

    render() {
        // let market = this.props.market
        // let book = this.state.book
        // market.expo = this.props.mktExpos[this.props.market.marketId]
        // market.agentExpo = this.props.mktAgentExpos[this.props.market.marketId]
        // let marketExpo = !!this.props.mktExpos[this.props.market.marketId] ? this.props.mktExpos[this.props.market.marketId].runnersExposure : null
        // let marketAgentExpo = !!this.props.mktAgentExpos && !!this.props.mktAgentExpos[this.props.market.marketId] ? this.props.mktAgentExpos[this.props.market.marketId].runnersExposure : null
        // let multiplayFector = market.marketCondition.volume
        const runnersTotalExpoKeys = Object.keys(this.state.runnersTotalExpo);
        return (
            <>
                {!this.state.areAllZero && 
                    <div className="main-analysis mb-2">
                        <div className="top">
                            <div className="toptitle d-inline pt-0" style={{ cursor: "pointer" }}>ComboBook</div>
                            <div className="min-max d-inline pt-0">
                                <span>
                                    <span className={"f-right pl-3"}>{!this.props.isComboBookOpen ? <i className="fa fa-plus" aria-hidden="true" onClick={(e) => { this.props.toggleComboBookOpen() }}></i> : <i className="fa fa-minus" aria-hidden="true" onClick={(e) => { this.props.toggleComboBookOpen() }}></i>}</span>
                                </span>
                            </div>
                        </div>
                        {this.props.isComboBookOpen &&
                            <div className="table-responsive analysis-running-market bookmakerbs  ">                          
                                <table className="w-100 bets">
                                    <tbody>                                        
                                            {
                                                !!runnersTotalExpoKeys && runnersTotalExpoKeys.map((rtek, i) =>{
                                                    const rtev= !!this.state.runnersTotalExpo[rtek] ? parseFloat(this.state.runnersTotalExpo[rtek]).toFixed(2) : 0;
                                                    return(
                                                        <tr className="bet-all-new">
                                                            <td><span className='in-play-title combobooktr'>{rtek}</span></td>
                                                            <td className='text-right'><span className={`in-play-title ${rtev<0?'text-danger':'text-success'} fbold combobooktr text-right`}> {rtev}</span></td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {/* <td><span className='in-play-title combobooktr'>Runner 2</span></td>
                                            <td><span className='in-play-title combobooktr'>Runner 3</span></td> */}
                                        {/* <tr className="bet-all-new">
                                            {
                                                !!runnersTotalExpoValues && runnersTotalExpoValues.map((rtev, i) =>{
                                                    return(
                                                        <td><span className={`in-play-title ${rtev<0?'text-danger':'text-success'} fbold combobooktr`}> {rtev}</span></td>
                                                    )
                                                })
                                            }
                                        </tr> */}
                                    </tbody>
                                </table>                           
                            </div>
                        }
                    </div>
                }
            </>
        )
    }
}
